"use strict";

const $ = require("jquery");
import "../lib/jquery.simpleTicker";

// calculate real ticker width
let ticker__width = 0;
$(".usps li").each(function () {
    ticker__width += $(this).outerWidth();
});

// store width and original usps in usps wrapper
$(".usps-wrapper").attr("data-width", ticker__width);
$(".usps-wrapper").attr("data-usps", $(".usps-wrapper").html());

class Ticker {
    constructor() {
        let init = false;

        function ticker() {
            // activate ticker when usps don’t fit
            if ($(window).width() <= $(".usps-wrapper").attr("data-width")) {
                $(".usps-wrapper").html($(".usps-wrapper").attr("data-usps"));

                $.simpleTicker($(".usps"), {
                    speed: 1500,
                    delay: 4000,
                    easing: "swing",
                    effectType: "slide",
                });
            }

            // reset usps to original
            if ($(window).width() > $(".usps-wrapper").attr("data-width")) {
                $(".usps-wrapper").html($(".usps-wrapper").attr("data-usps"));
                $(".usps li").each(function () {
                    $(this).css("opacity", 1);
                });
            }
        }

        // don’t trigger resize while dragging
        function debouncer(func, timeout) {
            var timeoutID,
                timeout = timeout || 200;
            return function () {
                var scope = this,
                    args = arguments;
                clearTimeout(timeoutID);
                timeoutID = setTimeout(function () {
                    func.apply(scope, Array.prototype.slice.call(args));
                }, timeout);
            };
        }

        $(window).on(
            "resize",
            debouncer(function () {
                // prevents double ticker start on page load
                if (!init) {
                    init = true;
                    ticker();
                    return;
                }
                ticker();
            })
        );

        // trigger function on page load
        ticker();
        
    }
}

module.exports = Ticker;
